import { ContactRoute } from '@/modules/member/routes/contact.routes';
import { ContactRouteConfig } from '@/modules/member/routes/ContactRouteConfig';
import { RouteConfig } from 'vue-router';

export const router: RouteConfig[] = [
  ContactRouteConfig.factory({
    path: `/${ContactRoute.CONTACT.path}`,
    name: ContactRoute.CONTACT.name,
    component: () => import('/@/modules/member/pages/ContactsPage.vue'),
    children: [
      {
        path: `/${ContactRoute.CONTACT_ESTATE_STAKEHOLDERS.path}`,
        name: ContactRoute.CONTACT_ESTATE_STAKEHOLDERS.name,
        component: () => import('/@/modules/member/pages/ContactEstateStakeholderPage.vue')
      },
      {
        path: `/${ContactRoute.CONTACT_PROFESSIONALS.path}`,
        name: ContactRoute.CONTACT_PROFESSIONALS.name,
        component: () => import('/@/modules/member/pages/ContactProfessionalPage.vue')
      },
      {
        path: `/${ContactRoute.CONTACT_FAMILY_TREE.path}`,
        name: ContactRoute.CONTACT_FAMILY_TREE.name,
        component: () => import('/@/modules/familytree/pages/FamilyTreePage.vue')
      }
    ]
  }).build() as RouteConfig
];
